<template>
    <sections>
        <section-jumbo
            color="bg-gray-900"
            :image="jumbo.image"
            :imageSizes="jumbo.imageSizes"
            :imageSet="jumbo.imageSet"
            imageOpacity="opacity-60"
            :heading="$config.public.siteName"
            headingColor="text-white"
            :content="'<p>' + $config.public.siteStrapline + '</p>'"
            contentColor="text-gray-200"
            :textCentered="false"
        ></section-jumbo>
        <section-text
            heading="Who We Are"
            heading-component="h2"
            content="<article-who />"
            buttonText="Procedure Details"
            :buttonUrl="$config.public.files + 'procedure-details.pdf'"
        ></section-text>
        <section-text
            color="bg-gray-50"
            heading="About Us"
            heading-component="h2"
            content="<article-about />"
        ></section-text>
        <section-text heading="What We Do" heading-component="h2" content="<article-what />"></section-text>
        <section-text
            color="bg-gray-50"
            heading="Our Expertise in Crude Oil Tankers"
            heading-component="h2"
            content="<article-expertise />"
        ></section-text>
        <section-text heading="Why Choose Us?" heading-component="h2" content="<article-why />"></section-text>
        <section-text
            color="bg-gray-50"
            heading="Contact Us"
            heading-component="h2"
            content="<article-contact />"
            buttonText="Contact Us"
            buttonRoute="/contact"
        ></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();

// https://www.responsivebreakpoints.com/
// https://cloudinary.com/tools/jpg-to-webp
const jumbo = {
    imageSizes: '100vw',
    imageSet: `
        ${$config.public.images}gsc-tanker-care-200.webp 200w,
        ${$config.public.images}gsc-tanker-care-679.webp 679w,
        ${$config.public.images}gsc-tanker-care-959.webp 959w,
        ${$config.public.images}gsc-tanker-care-1200.webp 1200w
    `,
    image: `${$config.public.images}gsc-tanker-care.jpg`,
};

useSeo().buildHead({
    title: $config.public.siteName,
    description: $config.public.siteStrapline,
    index: true,
});
</script>
